export default {
  notFound: {
    title: 'Página não encontrada',
    actionText: 'Página Inicial'
  }
}
